import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CircularProgress, Snackbar, Alert, Button, Container } from '@mui/material';
import { auth } from '../config/firebase';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../config/firebase';

const Home = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isAuthenticating, setIsAuthenticating] = useState(true);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');

    useEffect(() => {
        if (location.state?.snackbarMessage) {
            setSnackbarMessage(location.state.snackbarMessage);
            setSnackbarOpen(true);
        }
    }, [location.state]);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (user) => {
            setIsAuthenticating(true);

            if (user) {
                console.log('Authenticated user:', user);
                try {
                    const usersRef = collection(db, 'users');
                    const q = query(usersRef, where('email', '==', user.email), where('isAdmin', '==', true));
                    const querySnapshot = await getDocs(q);
                    querySnapshot.forEach(doc => {
                        console.log("Document ID:", doc.id, "=> Document Data:", doc.data());
                    });

                    if (!querySnapshot.empty || user.email === 'autoseo.notifications@gmail.com') {
                        setIsLoggedIn(true);
                        const redirectUrl = localStorage.getItem('redirectAfterLogin');
                        if (redirectUrl) {
                            localStorage.removeItem('redirectAfterLogin');
                            navigate(redirectUrl);
                        } else {
                            console.log("Reached to destination");
                            navigate('/dashboard/statistics');
                        }
                    } else {
                        throw new Error('Access denied: You are not authorized to access this application.');
                    }
                } catch (error) {
                    console.error('Error checking admin access:', error);
                    setSnackbarMessage(error.message);
                    setSnackbarOpen(true);
                    console.log("Signout");
                    await auth.signOut();
                    navigate('/');
                    console.log("Signout -> Home Page Back");
                }
            }
            else {
                setIsLoggedIn(false);
                if (isLoggedIn) {
                    console.log("Home Page Back");
                    navigate('/');
                }
            }
            setIsAuthenticating(false);
        });

        return () => unsubscribe();
    }, [navigate, isLoggedIn]);

    useEffect(() => {
        if (location.state?.snackbarMessage) {
            setSnackbarMessage(location.state.snackbarMessage);
            setSnackbarOpen(true);
        }
    }, [location.state]);

    const signInWithGoogle = async () => {
        console.log("signInWithGoogle PESSED...");
        const provider = new GoogleAuthProvider();
        try {
            console.log("Attempting to sign in with Google...");
            const userCredential = await signInWithPopup(auth, provider);
            console.log("Sign-in successful:", userCredential);
            const user = userCredential.user;

            // Query Firestore to check for admin access
            const usersRef = collection(db, 'users');
            const q = query(usersRef, where('email', '==', user.email), where('isAdmin', '==', true));
            const querySnapshot = await getDocs(q);

            querySnapshot.forEach(doc => {
                console.log("Document ID:", doc.id, "=> Document Data:", doc.data());
            });

            if (!querySnapshot.empty || user.email === 'autoseo.notifications@gmail.com') {
                const redirectUrl = localStorage.getItem('redirectAfterLogin');
                if (redirectUrl) {
                    localStorage.removeItem('redirectAfterLogin');
                    navigate(redirectUrl);
                } else {
                    console.log("Reached to destination");
                    navigate('/dashboard/statistics');
                }
            } else {
                throw new Error('Access denied: You are not authorized to access this application.');
            }
        } catch (error) {
            console.error('Error signing in with Google:', error.message);
            setSnackbarMessage(error.message);
            setSnackbarOpen(true);
        }
    };

    const containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        textAlign: 'center',
    };

    return (
        <Container maxWidth="md">
            {isAuthenticating ? (
                <div style={containerStyle}>
                    <CircularProgress />
                </div>
            ) : (
                <>
                    {!isLoggedIn && (
                        <div style={containerStyle}>
                            <div style={{ marginBottom: '20px' }}>
                                <h1>Welcome to XEO Admin Dashboard</h1>
                                <p>Manage Statistics, User Roles, Domains, and Configurations with Ease!</p>
                            </div>
                            <Button variant="contained" color="primary" onClick={signInWithGoogle}>
                                Sign in with Google
                            </Button>
                        </div>
                    )}
                </>
            )}
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={8000}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                onClose={() => setSnackbarOpen(false)}
            >
                <Alert onClose={() => setSnackbarOpen(false)} severity="error" sx={{ width: '100%' }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Container>
    );
};

export default Home;
